import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import AdminMenu from './components/adminMenu';
import Cars from './components/cars';
import AddCar from './components/addCar';
import CarData from './components/carData';
import Empty from './components/Empty';
import EditAddCarData from './components/changeCarData';
import Settings from './components/Settings';

import containerActions from './actions';

import './styles.scss';

class CarEditor extends Component {
  constructor () {
    super();
    this.state = {
      scrollLeft: 0
    };
  }

  componentWillMount() {
    this.props.checkAuthorization();
    if (this.props.pageControl.menu === '') this.props.setMenuPage('cars');
  }
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll, true);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll, true);
  }
  handleScroll = (e) => {
    if (e.target.scrollLeft > 0) {
      this.setState({
        scrollLeft: e.target.scrollLeft
      });
    } else if (e.target.scrollLeft === 0 && this.state.scrollLeft !== 0) {
      this.setState({
        scrollLeft: e.target.scrollLeft
      });
    }
  }
  showActiveMenu = () => {
    switch (this.props.pageControl.menu) {
      case 'clients': return (
        <Empty />
      );
      case 'cars': return (
        <Cars
          setSubMenu={this.props.setSubMenu}
          pageControl={this.props.pageControl}
          scrollLeft={this.state.scrollLeft}
        />
      );
      case 'dealers': return (
        <Empty />
      );
      case 'finances': return (
        <Empty />
      );
      case 'integrations': return (
        <Empty />
      );
      case 'settings': return (
        <Settings />
      );
      default: return (
        <Cars
          setSubMenu={this.props.setSubMenu}
          pageControl={this.props.pageControl}
          scrollLeft={this.state.scrollLeft}
        />
      );
    }
  }
  showActionPage = () => {
    switch (this.props.pageControl.actionPage) {
      case 'addCar': return (
        <AddCar
          scrollLeft={this.state.scrollLeft}
        />
      );
      case 'carData': return (
        <CarData
          scrollLeft={this.state.scrollLeft}
        />
      );
      case 'editCarData': return (
        <EditAddCarData
          scrollLeft={this.state.scrollLeft}
        />
      );
      default: return (
        <Empty />
      );
    }
  }
  render() {
    return (
      <div className="carEditor-mainfield">
        <div className="carEditor-mainfieldBody">
          <div
            className="carEditor-menu"
            style={this.state.scrollLeft > 1 ? { left: `-${this.state.scrollLeft}px` } : { }}
          >
            <AdminMenu
              logoutFunction={this.props.logoutAdmin}
              setMenuPage={this.props.setMenuPage}
              pageControl={this.props.pageControl}
            />
          </div>
          { this.props.pageControl.actionPage !== '' ?
                  this.showActionPage() : (
                    <div className="carEditor-body">
                      {
                        this.showActiveMenu()
                      }
                    </div>
                  )
                  }
        </div>
      </div>
    );
  }
}


CarEditor.propTypes = {
  // createAdminUser: PropTypes.func.isRequired,
  checkAuthorization: PropTypes.func.isRequired,
  logoutAdmin: PropTypes.func.isRequired,
  setMenuPage: PropTypes.func.isRequired,
  setSubMenu: PropTypes.func.isRequired,
  pageControl: PropTypes.instanceOf(Object).isRequired
};
const mapStateToProps = state => ({
  pageControl: state.careditor.pageControl,
  cars: state.careditor.cars
});

export default connect(mapStateToProps, containerActions)(CarEditor);



// WEBPACK FOOTER //
// ./src/pages/CarEditorPage/index.js